import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "ps-recipe-editor-page page" }
const _hoisted_2 = {
  key: 0,
  class: "success-message"
}
const _hoisted_3 = {
  key: 1,
  class: "error-message"
}
const _hoisted_4 = { class: "mode-toggle" }
const _hoisted_5 = { class: "form-section" }
const _hoisted_6 = { class: "field" }
const _hoisted_7 = { class: "field" }
const _hoisted_8 = { class: "form-section" }
const _hoisted_9 = { class: "meta-inputs" }
const _hoisted_10 = { class: "field" }
const _hoisted_11 = { class: "field" }
const _hoisted_12 = { class: "field" }
const _hoisted_13 = { class: "form-section" }
const _hoisted_14 = { class: "form-section" }
const _hoisted_15 = { class: "editor" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "form-section" }
const _hoisted_18 = {
  key: 0,
  class: "current-image"
}
const _hoisted_19 = ["src"]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "actions" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = {
  key: 3,
  class: "preview"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_form_field = _resolveComponent("form-field")!
  const _component_ingredient_editor = _resolveComponent("ingredient-editor")!
  const _component_recipe_view = _resolveComponent("recipe-view")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.isEditing ? 'Edit Recipe' : 'New Recipe'), 1),
    (_ctx.successMessage)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.successMessage), 1))
      : _createCommentVNode("", true),
    (_ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        class: _normalizeClass({ active: _ctx.mode === 'edit' }),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.mode = 'edit'))
      }, "Edit", 2),
      _createElementVNode("button", {
        class: _normalizeClass({ active: _ctx.mode === 'preview' }),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.mode = 'preview'))
      }, "Preview", 2)
    ]),
    (_ctx.mode === 'edit')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", _hoisted_5, [
            _cache[17] || (_cache[17] = _createElementVNode("h2", null, "Basic Info", -1)),
            _createVNode(_component_form_field, {
              modelValue: _ctx.title,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.title) = $event)),
              label: "Title"
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_6, [
              _cache[15] || (_cache[15] = _createElementVNode("label", null, "Description", -1)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.description) = $event)),
                placeholder: "Brief description of the recipe"
              }, null, 512), [
                [_vModelText, _ctx.description]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[16] || (_cache[16] = _createElementVNode("label", null, "Tags (comma-separated)", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.tagsInput) = $event)),
                placeholder: "e.g., main, quick, vegetarian"
              }, null, 512), [
                [_vModelText, _ctx.tagsInput]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[21] || (_cache[21] = _createElementVNode("h2", null, "Time & Servings", -1)),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _cache[18] || (_cache[18] = _createElementVNode("label", null, "Prep Time (minutes)", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.prepTime) = $event))
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.prepTime,
                    void 0,
                    { number: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[19] || (_cache[19] = _createElementVNode("label", null, "Cook Time (minutes)", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.cookTime) = $event))
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.cookTime,
                    void 0,
                    { number: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[20] || (_cache[20] = _createElementVNode("label", null, "Servings", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.servings) = $event))
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.servings,
                    void 0,
                    { number: true }
                  ]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_ingredient_editor, {
              modelValue: _ctx.ingredientRows,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.ingredientRows) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _cache[22] || (_cache[22] = _createElementVNode("h2", null, "Instructions", -1)),
            _cache[23] || (_cache[23] = _createElementVNode("p", { class: "hint" }, "Use Markdown for formatting. Use numbered lists for steps.", -1)),
            _createElementVNode("div", _hoisted_15, [
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.instructions) = $event)),
                placeholder: "1. First step..."
              }, null, 512), [
                [_vModelText, _ctx.instructions]
              ]),
              _createElementVNode("div", {
                class: "rendered",
                innerHTML: _ctx.compiledInstructions
              }, null, 8, _hoisted_16)
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _cache[24] || (_cache[24] = _createElementVNode("h2", null, "Image", -1)),
            (_ctx.pictureUrl)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("img", {
                    src: _ctx.pictureUrl,
                    alt: "Current recipe image"
                  }, null, 8, _hoisted_19),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.pictureUrl = ''))
                  }, "Remove")
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("input", {
              type: "file",
              onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args))),
              accept: "image/*"
            }, null, 32),
            (_ctx.imageData)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.uploadImage && _ctx.uploadImage(...args))),
                  disabled: _ctx.uploading
                }, _toDisplayString(_ctx.uploading ? 'Uploading...' : 'Upload Image'), 9, _hoisted_20))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("button", {
              class: "submit",
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
              disabled: _ctx.saving
            }, _toDisplayString(_ctx.saving ? 'Saving...' : (_ctx.isEditing ? 'Save Changes' : 'Create Recipe')), 9, _hoisted_22),
            _createElementVNode("button", {
              class: "cancel",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$router.push('/recipes')))
            }, "Cancel")
          ])
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createVNode(_component_recipe_view, { recipe: _ctx.previewRecipe }, null, 8, ["recipe"])
        ])),
    _createVNode(_component_Footer)
  ]))
}